export default __webpack_public_path__ + "static/media/laptop.30718090.jfif";